import type { ReactElement } from 'react';
import type {
  ApprovalSubmissionResult,
  OnUserInteraction,
  ToolInvocationEvent,
} from '../types';
import mergeIncidentsApprovalRenderer from '../toolRenderers/MergeIncidentsToolRenderer/MergeIncidentsToolRenderer';
import applyCloudTestConfigPlanApprovalRenderer from '../toolRenderers/ApplyCloudTestConfigPlanToolRenderer';
import applyCodeTestConfigPlanApprovalRenderer from '../toolRenderers/ApplyCodeTestConfigPlanToolRenderer';
import applyCustomSqlTestConfigPlanApprovalRenderer from '../toolRenderers/ApplyCustomSqlTestConfigPlanToolRenderer';
import runWarehouseQueryApprovalRenderer from '../toolRenderers/RunWarehouseQueryToolRenderer';

export type ApprovalToolRendererProps = {
  invocation: ToolInvocationEvent['toolInvocation'];
  onApproveToolUse: (
    approved: boolean,
    newArgs?: Record<string, unknown>,
  ) => Promise<ApprovalSubmissionResult>;
  onUserInteraction?: OnUserInteraction;
  isActive: boolean;
  interactionsDisabled?: boolean;
};

export type ApprovalToolRendererFn = (
  props: ApprovalToolRendererProps,
) => ReactElement | null;

const approvalRendererMap: Record<string, ApprovalToolRendererFn> = {
  merge_incidents: mergeIncidentsApprovalRenderer,
  apply_cloud_test_config_plan: applyCloudTestConfigPlanApprovalRenderer,
  apply_code_test_config_plan: applyCodeTestConfigPlanApprovalRenderer,
  apply_custom_sql_test_config_plan:
    applyCustomSqlTestConfigPlanApprovalRenderer,
  run_warehouse_query: runWarehouseQueryApprovalRenderer,
};

export const getApprovalToolRenderer = (
  toolName?: string,
): ApprovalToolRendererFn | undefined =>
  toolName ? approvalRendererMap[toolName] : undefined;
